<script>
  import { _ } from 'svelte-i18n'
  import { createEventDispatcher } from 'svelte'
  import { previews_nav_filters } from './../stores'
  import PreviewsStepperButton from './PreviewsStepperButton.svelte'
  
  const dispatch = createEventDispatcher()
    
  export let filtered_preview_count
  export let selected_preview_count
  
  $: show_select_all = !$previews_nav_filters.selected && selected_preview_count !== filtered_preview_count
  $: show_deselect_all = selected_preview_count > 1

</script>

<div class="wrapper">
	<PreviewsStepperButton on:click={() => dispatch('selectAllFonts')} disabled={!show_select_all}>{$_('buttons.selectAll')}</PreviewsStepperButton>
  <span> / </span>
  <PreviewsStepperButton on:click={() => dispatch('deselectAllFonts')} disabled={!show_deselect_all}>{$_('buttons.deselectAll')}</PreviewsStepperButton>
</div>

<style>
  .wrapper {
    display: inline-block;
  }
  span {
    color: var(--c-text-faded-big);
		user-select: none;
  }
</style>